// Mobile menu toggle. The header carries .gh-head-open while the menu is shown.
export default function menu() {
    const burger = document.querySelector(".gh-burger");
    const head = document.getElementById("gh-head");
    if (!burger || !head) return;
    burger.addEventListener("click", () => {
        const open = head.classList.toggle("gh-head-open");
        burger.setAttribute("aria-expanded", String(open));
        const label = burger.querySelector("span"); if (label) label.textContent = open ? "Close" : "Menu";
    });
}
